import {Route, Routes, Navigate} from 'react-router-dom'
import {Main} from './main'
import {NewsPage} from './news'
import {NewsAllPage} from './newsAll'
import {RepresentativePage} from './representative';
import {AreasOfWorkPage} from './areas-of-work';

export const Router = () => {
    return (
        <Routes>
            <Route path='/' element={<Main/>}/>
            <Route path='/news/:id' element={<NewsPage/>}/>
            <Route path='/news' element={<NewsAllPage/>}/>
            <Route path='/representative/:id' element={<RepresentativePage/>}/>
            <Route path='/areas-of-work' element={<AreasOfWorkPage/>} />
            <Route
                path="*"
                element={<Navigate to="/" replace />}
            />
        </Routes>
    )
}
